import { API, unwrapData } from '../axios-instance'

export const getApiStatus = async () => {
  return API.get<boolean>('/status').then(unwrapData)
}
